import { graphql } from '@/generated/gql';

export const SUPPLIER_LIST_WIDGET_QUERY = graphql(/* GraphQL */ `
  query SupplierListWidget($id: UUID!) {
    cataclysm {
      risk(id: $id) {
        id
        suppliers {
          id
          status
          score
        }
      }
    }
  }
`);
